import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import withGlobalData from 'components/providers/global-data';

import Login from '../views/login';
import Users from '../views/users';
import InventoryReport from '../views/inventory-report';
import ubicacionAgregar from '../views/ubicacion-agregar';
import EditInventoryReport from '../views/edit-inventory-report';
import LocationCount from '../views/location-count';
import LocationStatus from '../views/location-status';
import NotFound from '../views/not-found';
import Welcome from '../views/welcome';
import Reports from '../views/reports';

const PublicRoutes = () => (
  <Switch>
    <Route exact path="/login" render={routerProps => <Login {...routerProps} />} />
    <Redirect to="/login" />
  </Switch>
);

const PrivateRoute = props => {
  const { component: Component, role, roles } = props;

  return (
    <Route
      render={routerProps =>
        roles.includes(role) ? <Component {...props} {...routerProps} /> : <NotFound />
      }
    />
  );
};

const PrivateRoutes = withGlobalData(props => {
  const { user } = props;
  let role = '';

  if (user) {
    role = user.role;
  }

  return (
    <Switch>
      <Redirect from="/login" to="/" />
      <PrivateRoute
        exact
        path="/usuarios"
        component={Users}
        role={role}
        roles={['SUPER_ADMIN']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/crear-ubicacion"
        component={ubicacionAgregar}
        role={role}
        roles={['SUPER_ADMIN']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/crear-inventario"
        component={InventoryReport}
        role={role}
        roles={['SUPER_ADMIN']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/modificar-inventario"
        component={EditInventoryReport}
        role={role}
        roles={['SUPER_ADMIN']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/conteo-ubicacion"
        component={LocationCount}
        role={role}
        roles={['SUPER_ADMIN', 'ADMIN', 'COUNTER']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/estatus-ubicaciones"
        component={LocationStatus}
        role={role}
        roles={['SUPER_ADMIN', 'ADMIN', 'AUDITOR']}
        {...props}
      />
      <PrivateRoute
        exact
        path="/reportes"
        component={Reports}
        role={role}
        roles={['SUPER_ADMIN', 'ADMIN', 'AUDITOR']}
        {...props}
      />
      <Route exact path="/" component={Welcome} />
      <Route component={NotFound} />
    </Switch>
  );
});

export { PublicRoutes, PrivateRoutes };
